module.exports = __webpack_public_path__ + "img/airbnb.5dde6a84.svg";